import React from 'react';
import { Route, Redirect } from 'react-router';

import { authorities } from 'app/dealer/constants';
import { GuardedRoute } from 'app/dealer/shared/components/GuardedRoute/GuardedRoute';
import { fetchAuthorities } from 'app/dealer/shared/modules/authorities/actions';

const { MANAGE_MY_NETWORK, READ_MY_NETWORK } = authorities;
const requiredAuthorities = [MANAGE_MY_NETWORK, READ_MY_NETWORK];
const refreshAuthorities = ({ dispatch }) => {
  return (nextState, replace, next) => {
    return dispatch(fetchAuthorities())
      .then(() => next())
      .catch(() => next());
  };
};

export const getServiceRoutes = (store) => {
  return (
    <Route name="service" onEnter={refreshAuthorities(store)}>
      <Redirect from="/dealer/service" to="/dealer/service/contact" />
      <GuardedRoute
        getState={store.getState}
        getComponent={() =>
          import('./Service/ConnectedService').then((c) => c.ConnectedService)
        }
        path="/dealer/service"
        requiredAuthorities={requiredAuthorities}
        redirectTo="/dealer/login"
      >
        <Route
          path="/dealer/service/contact"
          getComponent={() =>
            import('./ServiceContact/ServiceContact').then(
              (c) => c.ServiceContact
            )
          }
        />
        <Route
          path="/dealer/service/faq"
          getComponent={() =>
            import('./ServiceFaq/ConnectedServiceFaq').then(
              (c) => c.ConnectedServiceFaq
            )
          }
        />
        <Route
          path="/dealer/service/agb"
          getComponent={() =>
            import('./ServiceAgb/ServiceAgb').then((c) => c.ServiceAgb)
          }
        />
      </GuardedRoute>
    </Route>
  );
};
